import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ModuleGetByPageService } from '../../services';

export const fetchModuleGetAllByPage = createAsyncThunk(
    'moduleGetAllByPage/fetchModuleGetAllByPage',
    async ({ id }) => {
        const response = await ModuleGetByPageService(id)
        return response.result
    }
);

const moduleGetAllByPageSlice = createSlice({
    name: 'moduleGetAllByPage',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchModuleGetAllByPage.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModuleGetAllByPage.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchModuleGetAllByPage.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default moduleGetAllByPageSlice.reducer;
